import React from 'react';

/**
 * ImageDownloadIcon Component
 *
 * Reusable download icon for images that appears on hover
 * Used in DocumentRenderer and TiffRenderer
 *
 * @param {string} docValue - The image data/source URL
 * @param {string} docName - The image filename for download
 */
const ImageDownloadIcon = ({ docValue, docName }) => {
  return (
    <a
      href={docValue}
      download={docName}
      className="image-download-icon w_20x h_20x flex_center rounded position-absolute d-flex justify-content-center align-items-center text-decoration-none cursor-pointer text-white top-0 end-0 me-1 mt-1"
      title="Download image"
    >
      <i className="fas fa-download font_10"></i>
    </a>
  );
};

export default ImageDownloadIcon;
